<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>引荐类型：</label>
                <el-select v-model="search_Obj.f_recommend_type" clearable placeholder="请选择">
                    <el-option v-for="item in enuObj('recommend_type')" :key="'recommend_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>老用户邮箱：</label>
                <el-input v-model="search_Obj.f_mail" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>新用户姓名：</label>
                <el-input v-model="search_Obj.f_new_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>新用户邮箱：</label>
                <el-input v-model="search_Obj.f_new_mail" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>新用户手机号：</label>
                <el-input v-model="search_Obj.f_new_cellnum" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>是否回填：</label>
                <el-select v-model="search_Obj.f_is_back" clearable placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNo1'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>是否处理：</label>
                <el-select v-model="search_Obj.f_state" clearable placeholder="请选择">
                    <el-option v-for="item in enuObj('yesNo')" :key="'yesNo2'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>提交时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="recommend_type" label="引荐类型" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.recommend_type, "recommend_type") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mail" label="老用户邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="new_name" label="新用户姓名" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="new_mail" label="新用户邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="new_cellnum" label="新用户手机号" sortable="custom"></el-table-column>
                <el-table-column prop="province" label="地区" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ scope.row.province }} {{ scope.row.city }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="添加时间" sortable="custom"></el-table-column>
                <el-table-column prop="is_back" label="是否回填" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.is_back, "yesNo") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="是否处理" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "yesNo") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看试驾引荐"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'testDriveRecommendList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '试驾引荐',
            menu_id: 8410,
            list_url: "/api/admin/testdriverecommend/list",
            search_Obj: {
                f_recommend_type: '',
                f_mail: '',
                f_new_name: '',
                f_new_mail: '',
                f_new_cellnum: '',
                f_state: '',
                f_is_back: '',
                f_add_time_s_date: '',
                f_add_time_e_date: '',
            },
            del_Obj:{
                url:'/api/admin/testdriverecommend/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['recommend_type', 'yesNo'],
            dateRange: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
    }
};
</script>